"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorLabel = exports.inputContainer = exports.wrapperStyles = exports.lableStyle = void 0;

var _emotion = require("emotion");

var _styleConsts = require("../utils/styleConsts");

var lableStyle = function lableStyle(_ref, active, focus, error) {
  var color = _ref.color;
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:absolute;color:", color.black3, ";top:2px;transition:", _styleConsts.transition['f-font-size'], ",", _styleConsts.transition['f-top'], ";// transform-origin:left top;font-size:16px;cursor:text;pointer-events:none;", active && "\n    top: -17.5px;\n    font-size: 14px;\n  ", "\n  ", focus && "\n    color: ".concat(color.accent, ";\n  "), "\n  ", error && focus && "\n  color: ".concat(color.red, ";\n  "), ";")
  );
}; // width: 66.6%;


exports.lableStyle = lableStyle;

var wrapperStyles = function wrapperStyles(_ref2) {
  var color = _ref2.color;
  return (
    /*#__PURE__*/
    (0, _emotion.css)("width:100%;position:relative;&.active input::placeholder{opacity:1;}& input{border:none;outline:none;font-size:1em;color:", color.black1, ";padding:3px 0px;position:relative;z-index:1;}& input::placeholder{color:", color.black3, ";opacity:0;transition:opacity 0.2s ease;}& .noLabel input::placeholder{opacity:1;}&.active textarea::placeholder{opacity:1;}& textarea{border:none;outline:none;font-size:1em;color:", color.black1, ";padding:3.5px 0px;position:relative;z-index:1;cursor:auto;}& textarea::placeholder{color:", color.black3, ";opacity:0;transition:opacity 0.2s ease;}& .noLabel textarea::placeholder{opacity:1;}&:focus ~ label{color:yellow;}")
  );
};

exports.wrapperStyles = wrapperStyles;

var inputContainer = function inputContainer(_ref3, fontSize, error, warning, focus) {
  var color = _ref3.color;
  return (
    /*#__PURE__*/
    (0, _emotion.css)("display:flex;flex-direction:column;justify-content:flex-end;position:relative;border-bottom:1px solid ", color.grey2, ";", error && "border-bottom: 1px solid ".concat(color.red), ";", warning && "border-bottom: 1px solid ".concat(color.yellow), ";font-size:16px;position:relative;&::after{left:0;width:0px;bottom:-1px;content:\"\";position:absolute;transition:all 0.3s ease;border-bottom:1px solid ", color.accent, ";pointer-events:none;", focus && !error && "\n      width: 100%;\n    ", ";}&::before{left:0;right:0;bottom:-1px;content:\"\";position:absolute;transition:border-bottom-color 200ms cubic-bezier(0.4,0,0.2,1) 0ms;border-bottom:1px solid transparent;pointer-events:none;", focus && !error && "\n      border-bottom: 0px;\n    ", ";}&:hover{&::before{", !focus && !error && "\n        border-bottom: 1px solid ".concat(color.black3, ";\n      "), ";}}")
  );
};

exports.inputContainer = inputContainer;

var errorLabel = function errorLabel(_ref4, error) {
  var color = _ref4.color;
  return (
    /*#__PURE__*/
    (0, _emotion.css)("position:absolute;bottom:-24px;left:0;color:", error ? color.red : color.yellow, ";font-size:", _styleConsts.font.size.medium, ";")
  );
};

exports.errorLabel = errorLabel;